import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useDeepLinkRedirection from './hooks/useDeepLinkRedirection';

declare module '@stackflow/config' {
    interface Register {
        DeepLinkActivity: {
            projectId: string;
        }
    }
}

const DeepLinkActivity: ActivityComponentType<'DeepLinkActivity'> = ({ params }) => {
    const { projectId } = params;
    useDeepLinkRedirection(projectId);
    return (
        <AppScreen>
            <Loading/>
        </AppScreen>
    );
};

export default DeepLinkActivity;
